import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import Notification from '@ynap/notification';

const bem = new BEMHelper('ValidatedField');

const propTypes = {
    label: PropTypes.string,
    htmlFor: PropTypes.string,
    error: PropTypes.string,
    help: PropTypes.string,
    errorStyle: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
    showErrorNotification: PropTypes.bool,
    notificationType: PropTypes.bool,
    customLabel: PropTypes.shape({
        labelName: PropTypes.string,
        LabelWrap: PropTypes.elementType,
        extraElements: PropTypes.node,
    }),
};

const defaultProps = {
    errorStyle: 'error',
    customLabel: {
        labelName: null,
        LabelWrap: null,
        extraElements: null,
    },
    showErrorNotification: true,
};

export const renderLabel = ({ customLabel, htmlFor, label }) => {
    if (!label && !customLabel?.labelName) return null;

    if (customLabel?.LabelWrap) {
        return (
            <customLabel.LabelWrap {...customLabel.labelWrapProps}>
                <label className={bem('label')} htmlFor={htmlFor}>
                    {customLabel.labelName}
                </label>
                {customLabel.extraElements}
            </customLabel.LabelWrap>
        );
    }

    return (
        <label className={bem('label')} htmlFor={htmlFor}>
            {label}
        </label>
    );
};

function ValidatedField(props) {
    const { children, className, error, errorStyle, help, htmlFor, notificationType = 'field-error', showErrorNotification } = props;

    const childrenWithProps = React.Children.map(children, (child) =>
        typeof child.type !== 'string' ? React.cloneElement(child, { hasError: error }) : child,
    );

    const errorToDisplay = showErrorNotification ? error : null;
    const classNames = [className, errorToDisplay && className ? `${className}--error` : ''];

    return (
        <div className={bem(null, { [htmlFor]: true, error: errorToDisplay }, classNames)}>
            {renderLabel(props)}
            {childrenWithProps}
            {errorToDisplay && (
                <Notification className={bem(errorStyle)} message={errorToDisplay} type={notificationType} />
            )}
            {!errorToDisplay && help && (
                <span className={bem('help')}>{help}</span>
            )}
        </div>
    );
}

ValidatedField.propTypes = propTypes;
ValidatedField.defaultProps = defaultProps;

export default ValidatedField;
